// extracted by mini-css-extract-plugin
export default {"container":"cec-hours__container___3MmrI","title":"cec-hours__title___xxVij","hours":"cec-hours__hours___34MDd","divider":"cec-hours__divider___I8H4H"};